module.exports = __webpack_public_path__ + "img/we-do-right-thing.a9da905f.png";